import * as types from '../ActionTypes/MembersActionTypes';

export class MembersActionCreators {
    // get members
    static getMembersRequest = () => ({
        type: types.GET_MEMBERS_REQUEST,
    });

    static getMembersSuccess = payload => ({
        type: types.GET_MEMBERS_SUCCESS,
        payload,
    });

    static getMembersFailed = payload => ({
        type: types.GET_MEMBERS_FAILED,
        payload,
    });

    // add member
    static addMemberRequest = (userData, callback) => ({
        type: types.ADD_MEMBER_REQUEST,
        meta: { userData, callback },
    });

    static addMemberSuccess = payload => ({
        type: types.ADD_MEMBER_SUCCESS,
        payload,
    });

    static addMemberFailed = payload => ({
        type: types.ADD_MEMBER_FAILED,
        payload,
    });

    // assign membership plan to member
    static addMembershipPlanToMemberRequest = (id, plans, cb) => ({
        type: types.ADD_PLANS_TO_MEMBER_REQUEST,
        meta: { id, plans, cb },
    });

    static addMembershipPlanToMemberSuccess = payload => ({
        type: types.ADD_PLANS_TO_MEMBER_SUCCESS,
        payload,
    });

    static addMembershipPlansToMemberFailed = error => ({
        type: types.ADD_PLANS_TO_MEMBER_FAILED,
        payload: error,
    });

    // update member
    static updateMemberRequest = (memberId, creditsData) => ({
        type: types.UPDATE_MEMBER_REQUEST,
        meta: { memberId, creditsData },
    });

    static updateMemberSuccess = payload => ({
        type: types.UPDATE_MEMBER_SUCCESS,
        payload,
    });

    static updateMemberFailed = payload => ({
        type: types.UPDATE_MEMBER_FAILED,
        payload,
    });

    // delete member
    static deleteMemberRequest = (memberId, callback) => ({
        type: types.DELETE_MEBMER_REQUEST,
        meta: { memberId, callback },
    });

    static deleteMemberSuccess = memberId => ({
        type: types.DELETE_MEMBER_SUCCESS,
        meta: { memberId },
    });

    static deletememberFailed = payload => ({
        type: types.DELETE_MEMBER_FAILED,
        payload,
    });

    // update membership plan for member
    static updateMembersMembershipPlanRequest = (memberId, planMemberId, planData) => ({
        type: types.UPDATE_MEMBERS_MEMBERSHIP_PLAN_REQUEST,
        meta: { memberId, planMemberId, planData },
    });

    static updateMembersMembershipPlanSuccess = payload => ({
        type: types.UPDATE_MEMBERS_MEMBERSHIP_PLAN_SUCCESS,
        payload,
    });

    static updateMembersMembershipPlanFailed = payload => ({
        type: types.UPDATE_MEMBERS_MEMBERSHIP_PLAN_FAILED,
        payload,
    });

    // get birthdays of members by date range
    static getMembersBirthdaysByDateRangeRequest = (start, end) => ({
        type: types.GET_MEMBERS_BIRTHDAYS_BY_DATE_RANGE_REQUEST,
        meta: { start, end },
    });

    static getMembersBirthdaysByDateRangeSuccess = payload => ({
        type: types.GET_MEMBERS_BIRTHDAYS_BY_DATE_RANGE_SUCCESS,
        payload,
    });

    static getMembersBirthdaysByDateRangeFailed = payload => ({
        type: types.GET_MEMBERS_BIRTHDAYS_BY_DATE_RANGE_FAILED,
        payload,
    });

    // invite member by email
    static inviteMemberByEmailRequest = (membersInfo, callback) => ({
        type: types.INVITE_MEMBER_BY_EMAIL_REQUEST,
        meta: { membersInfo, callback },
    });

    static inviteMemberByEmailSuccess = payload => ({
        type: types.INVITE_MEMBER_BY_EMAIL_SUCCESS,
        payload,
    });

    static inviteMemberbyEmailFailed = payload => ({
        type: types.INVITE_MEMBER_BY_EMAIL_FAILED,
        payload,
    });

    // get waiting members
    static getWaitingMembersRequest = () => ({
        type: types.GET_WAITING_MEMBERS_REQUEST,
    });

    static getWaitingMembersSuccess = payload => ({
        type: types.GET_WAITING_MEMBERS_SUCCESS,
        payload,
    });

    static getWaitingMembersFailed = payload => ({
        type: types.GET_WAITING_MEMBERS_FAILED,
        payload,
    });

    // get classes for plans
    static getClassesForPlansRequest = () => ({
        type: types.GET_CLASSES_FOR_PLANS_REQUEST,
    });

    static getClassesForPlansSuccess = payload => ({
        type: types.GET_CLASSES_FOR_PLANS_SUCCESS,
        payload,
    });

    static getClassesForPlansFailed = payload => ({
        type: types.GET_CLASSES_FOR_PLANS_FAILED,
        payload,
    });

    // assign classes to plan
    static assignClassesToPlanRequest = (planId, seriesIds) => ({
        type: types.ASSIGN_CLASSES_TO_PLAN_REQUEST,
        meta: { planId, seriesIds },
    });

    static assignClassesToPlanSuccess = payload => ({
        type: types.ASSIGN_CLASSES_TO_PLAN_SUCCESS,
        payload,
    });

    static assignClassesToPlanFailed = payload => ({
        type: types.ASSIGN_CLASSES_TO_PLAN_FAILED,
        payload,
    });

    // renend invitation request
    static resendInvitationRequest = memberId => ({
        type: types.RESEND_MEMBER_INVITATION_REQUEST,
        meta: { memberId },
    });

    static resendInvitationSuccess = payload => ({
        type: types.RESEND_MEMBER_INVITATION_SUCCESS,
        payload,
    });

    static resendInvitationFailed = payload => ({
        type: types.RESEND_MEMBER_INVITATION_FAILED,
        payload,
    });

    // update member status
    static updateMemberStatusRequest = (memberId, status, callback) => ({
        type: types.UPDATE_MEMBER_STATUS_REQUEST,
        meta: { memberId, status, callback },
    });

    static updateMemberStatusSuccess = payload => ({
        type: types.UPDATE_MEMBER_STATUS_SUCCESS,
        payload,
    });

    static udpateMemberStatusFailed = payload => ({
        type: types.UPDATE_MEMBER_STATUS_FAILED,
        payload,
    });
}



// WEBPACK FOOTER //
// ./src/Store/ActionCreators/MembersActionCreators.js